import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1rem',
    height: '1rem',
  },
  rect: {
    fill: 'white',
    strokeWidth: 1,
    stroke: 'black',
  },
});

const Checkbox = ({ checked }) => {
  const classes = useStyles();

  return (
    <SvgIcon viewBox="0 0 16 16" className={classes.icon}>
      <rect
        xmlns="http://www.w3.org/2000/svg"
        x="2"
        y="2"
        width="12"
        height="12"
        rx="2"
        className={classes.rect}
      />
      {checked && (
        <path
          d="M6.76537 9.02868L10.8551 5L12 6.12783L6.76537 11.2843L4 8.56024L5.14491 7.43241L6.76537 9.02868Z"
          fill="black"
        />
      )}
    </SvgIcon>
  );
};

export default memo(Checkbox);
